"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ltZones = void 0;
var ltZones = exports.ltZones = [{
  id: 'VILNIUS',
  name: 'Vilnius',
  country: 'LT',
  cornerNW: {
    latitude: 54.8322,
    longitude: 25.0699
  },
  cornerSE: {
    latitude: 54.5677,
    longitude: 25.4832
  },
  subZones: [{
    name: 'Vilnius Centre historique',
    zipcodes: {
      'LT-01001': {
        label: 'LT-01001'
      }
    }
  }, {
    name: 'Vilnius Verkiai',
    zipcodes: {
      'LT-02300': {
        label: 'LT-02300'
      }
    }
  }, {
    name: 'Vilnius Pilaité',
    zipcodes: {
      'LT-09300': {
        label: 'LT-09300'
      }
    }
  }, {
    name: 'Vilnius Jeruzalé',
    zipcodes: {
      'LT-13225': {
        label: 'LT-13225'
      }
    }
  }]
}];